import React from "react";
import './topBanner.css';

export default function TopBanner() {
    return(
        <div className="topBanner">
            <div className="topBannerContent">
                <h1>М-ГРУПП</h1>
                <h2>Инновации. Технологии. Производство.</h2>
                <p>Объединение высокотехнологичных инженерно-производственных, технологических компаний и проектов для совместного решения задач по внедрению отечественных разработок, созданию платформенных цифровых решений, расширению производства отечественного оборудования и внедрению инноваций на российском рынке.</p>
            </div>
        </div>
    )
}